// flow
// TODO(Oded): flow disabled due to SVGGraphicsElement not recognized
import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {SVGToBase64Url} from "../../../Utils/SVGUtils";
import {SVGAnchor} from "./SVGMarker";
import SVGMarker from "./SVGMarker";
import type {SVGMarkerProps, SVGMarkerState} from "./SVGMarker";
import { images } from '../../../config';
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";
import Markers from "../../../Store/Views/markers";


const updatePickupMarkerEta = (etaIconSVG: SVGGraphicsElement, etaDescription: string) => {
    var textDistanceFromLeft = 112 - (etaDescription.length * 4); //todo(Oded): this is horrible
    etaIconSVG.querySelector("#etaValue").innerHTML = etaDescription;
    etaIconSVG.querySelector("#etaValueContainer").setAttribute("x", textDistanceFromLeft.toString());
};

type ConnectedProps = {
    pickupLat: number,
    pickupLng: number,
    showPickupMarkerETA: boolean,
    ETADescription: string,
};

class PickupMarkerETA extends PureComponent<ConnectedProps> {

    derivedStateFromProps: (props: SVGMarkerProps, state: SVGMarkerState) => SVGMarkerState;

    constructor(props) {
        super(props);
        this.derivedStateFromProps = this.derivedStateFromProps.bind(this);
    }

    derivedStateFromProps(props: SVGMarkerProps, state: SVGMarkerState): SVGMarkerState {
        if (state.iconSVG && this.props.ETADescription) {
            updatePickupMarkerEta(state.iconSVG, this.props.ETADescription);
            return {
                iconURL: SVGToBase64Url(state.iconSVG),
                iconSVG: state.iconSVG,
            };
        }
        return state;
    }

    render() {
        return (<SVGMarker
            key={"pickupMarkerETASVG"}
            iconPath={images.pickup_marker_icon_eta}
            visible={this.props.showPickupMarkerETA}
            lat={this.props.pickupLat || 0}
            lng={this.props.pickupLng || 0}
            anchorPosition={SVGAnchor.BOTTOM_CENTER}
            derivedStateFromProps={this.derivedStateFromProps}
        />);
    }

}

const mapStateToProps = (state, props) => {
    return {
        pickupLat: CurrentRideSelectors.getPickupLat(state),
        pickupLng: CurrentRideSelectors.getPickupLng(state),
        showPickupMarkerETA: Markers.shouldShowPickupMarkerETA(state),
        ETADescription: CurrentRideSelectors.getETADescription(state),
    };
};

export default connect(mapStateToProps)(PickupMarkerETA);



// WEBPACK FOOTER //
// ./src/Components/Map/Markers/PickupMarkerETA.js